import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';

interface Props {
  onClick: () => void;
  isCoherent: boolean;
}

export const ExtractDataCoherentButton = ({ onClick, isCoherent }: Props) => {
  const { t } = useTranslation();

  const styles = `flex text-foreground rounded-l-[6px] rounded-r-none border border-r-0 border-border shadow-[0_1px_2px_0_rgba(0,0,0,0.10)] flex-1 transition-colors ${
    isCoherent ? 'bg-green-4 hover:bg-green-4' : 'bg-muted hover:bg-green-4'
  }`;

  return (
    <Button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={styles}
    >
      <Check className="w-4 h-4 text-green-600" />
      <span className="text-sm font-medium">
        {t('coverage.coherentExtraction')}
      </span>
    </Button>
  );
};
